import { createAsyncThunk } from '@reduxjs/toolkit';

import { Modals } from '@/constants';
import { growthbook } from '@/services';

import { RootState } from '../store';
import { selectIsFreeTrialUser } from '../user-api';
import {
  selectKeepGoingPromoLastShownAt,
  userPreferencesActions,
} from '../user-preferences';
import { UI_SLICE_KEY, uiActions } from './ui.slice';

const DAYS_TO_MS = 24 * 60 * 60 * 1000;

export const maybeShowKeepGoingPromo = createAsyncThunk<
  null,
  void,
  { state: RootState }
>(
  `${UI_SLICE_KEY}/maybeShowKeepGoingPromo`,
  async (_, { getState, dispatch }) => {
    const {
      code: promoCode,
      percentOff,
      cooldownPeriodInDays,
    } = growthbook.getFeatureValue('keep-going-promo-code', {
      code: null,
      percentOff: null,
      cooldownPeriodInDays: 30,
    });

    const lastShownAt = selectKeepGoingPromoLastShownAt(getState());
    const isFreeTrialUser = selectIsFreeTrialUser(getState());
    const cooldownPeriodInMs = cooldownPeriodInDays * DAYS_TO_MS;
    const isPromoAvailable =
      isFreeTrialUser &&
      !!promoCode &&
      !!percentOff &&
      (!lastShownAt ||
        new Date(lastShownAt).getTime() <
          new Date().getTime() - cooldownPeriodInMs);

    if (isPromoAvailable) {
      dispatch(userPreferencesActions.updateKeepGoingPromoLastShownAt());
      dispatch(
        uiActions.setActiveModal({
          name: Modals.KEEP_GOING_PROMO,
          params: { promoCode, percentOff },
        }),
      );
    }
    return null;
  },
);
